import request from 'tools/request'
import {
  AlertStatusUpdate,
  IAlertFeedResponse,
  ICompanyMonitoringData,
  IFleetBulkRequest,
  IFleetData,
  IFleetMonitoringResponse,
  IFleetUpdateData,
  IGeoArea,
  IRecipientCandidate,
  IValidationTypeData,
} from 'interfaces/IFleetMonitoring'

const getValidationTypes = async (): Promise<IValidationTypeData[]> => {
  const response = await request.get<IValidationTypeData[]>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/validation-types`
  )
  return response.data
}

const getGeoAreas = async (): Promise<IGeoArea[]> => {
  const response = await request.get<IGeoArea[]>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/geo-areas`
  )
  return response.data
}

const getRecipientCandidates = async (): Promise<IRecipientCandidate[]> => {
  const response = await request.get<IRecipientCandidate[]>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/recipient-candidates`
  )
  return response.data
}

const getCompanyMonitoring = async (): Promise<ICompanyMonitoringData> => {
  const response = await request.get<ICompanyMonitoringData>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/company`
  )
  return response.data
}

const saveCompanyMonitoring = async (
  payLoad: Partial<ICompanyMonitoringData>
): Promise<IFleetMonitoringResponse> => {
  const response = await request.put<IFleetMonitoringResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/company`,
    payLoad
  )
  return response.data
}

const getFleets = async (): Promise<IFleetData[]> => {
  const response = await request.get<IFleetData[]>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/fleets`
  )
  return response.data
}

const updateFleet = async (
  payLoad: IFleetUpdateData
): Promise<IFleetMonitoringResponse> => {
  const response = await request.put<IFleetMonitoringResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/fleets`,
    payLoad
  )
  return response.data
}

const bulkUpdateFleets = async (
  payLoad: IFleetBulkRequest
): Promise<IFleetMonitoringResponse> => {
  const response = await request.post<IFleetMonitoringResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/fleets/bulk`,
    payLoad
  )
  return response.data
}

const getAlerts = async (): Promise<IAlertFeedResponse> => {
  const response = await request.get<IAlertFeedResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/alerts`
  )
  return response.data
}

const updateAlertStatus = async (
  id: number,
  status: AlertStatusUpdate
): Promise<IFleetMonitoringResponse> => {
  const response = await request.put<IFleetMonitoringResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/alerts/${id}/status`,
    { status }
  )
  return response.data
}

const updateAlertStatuses = async (
  ids: number[],
  status: AlertStatusUpdate
): Promise<IFleetMonitoringResponse> => {
  const response = await request.put<IFleetMonitoringResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}fleet-monitoring/alerts/status`,
    { ids, status }
  )
  return response.data
}

export {
  getValidationTypes,
  getGeoAreas,
  getRecipientCandidates,
  getCompanyMonitoring,
  saveCompanyMonitoring,
  getFleets,
  updateFleet,
  bulkUpdateFleets,
  getAlerts,
  updateAlertStatus,
  updateAlertStatuses,
}
